import { Component } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {UserService} from "../../../@core/services/user.service";
import {USM_USR_13} from "../../../@shared/models/input.module";
import {CommonModule} from "@angular/common";
import {Router, RouterLink} from "@angular/router";
import {ToastService} from "../../../@core/services/toast.service";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-forgot-passord',
  templateUrl: './forgot-passord.component.html',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    RouterLink,
    TranslateModule
  ],
  styleUrl: './forgot-passord.component.css'
})
export class ForgotPassordComponent {
  resetForm: FormGroup;
  emailSent: boolean = false;
  isSubmitting: boolean = false;

  constructor(
    private userService: UserService,
    private toastService: ToastService,
    private router: Router
  ) { }

  ngOnInit() {
    this.resetForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  onSubmit(): void {
    if (this.resetForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      let payload: USM_USR_13 = {
        email: this.resetForm.get('email')!.value,
      }
      this.userService.initiatePasswordReset(payload).subscribe({
        next: (response) => {
          this.emailSent = true;
          this.toastService.success('Password reset email sent! Please check your inbox.');
          this.isSubmitting = false;
        },
        error: (error) => {
          this.toastService.error('Failed to send password reset email. Please try again.');
          this.isSubmitting = false;
        }
      });
    }
  }

  backToLogin(): void {
    this.router.navigate(['/auth/login']);
  }
}
